import { POReceivingPrintPage } from "@/features/po-receiving/pages/POReceivingPrintPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/receiving/$id/print")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["po_receiving.view_detail"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: POReceivingPrintPage,
});
